import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  modalContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    height: 1200,
    width: 1500,
  },
  amountStack: {
    fontWeight: 'bold',
  },
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
  onrenderColumnStack: {
    height: 25,
  },
  containerMain: { padding: 0, margin: 0 },
  container: { maxWidth: 300, minWidth: 200 },
  title: { color: theme.palette.white },
  urgentHeader: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '5px 10px',
    backgroundColor: `${theme.palette.redDark}`,
  },
  rowBaseStyle: { borderLeft: `5px solid transparent` },

  footerContainer: {
    position: 'sticky',
    bottom: 0,
    zIndex: 1,
    width: '100%',
  },
  footerStyle: {
    backgroundColor: theme.palette.neutralLighterAlt,
    boxShadow: `-1px -4px 13px rgba(0, 0, 0, 0.15)`,
  },
}));
